module.exports = __webpack_public_path__ + "img/441.da30ec45.jpg";